var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.isLoggedIn
        ? _c("div", { staticClass: "dropdown" }, [
            _c(
              "a",
              {
                attrs: {
                  id: "js--login",
                  "data-toggle": "dropdown",
                  "data-toggle-second": "tooltip",
                  "data-placement": "top",
                  title: _vm.$translate("OD3dprimaV2::Template.vatPlaceholder"),
                  "aria-label": _vm.$translate(
                    "OD3dprimaV2::Template.vatPlaceholder"
                  ),
                  href: "#",
                  "aria-expanded": "false",
                  "aria-haspopup": "true",
                  "data-boundary": "viewport",
                },
              },
              [
                _c(
                  "svg",
                  {
                    staticClass: "dia-controls-list__svg",
                    attrs: {
                      xmlns: "http://www.w3.org/2000/svg",
                      width: "22",
                      height: "19",
                    },
                  },
                  [
                    _c("use", {
                      attrs: {
                        "xmlns:xlink": "http://www.w3.org/1999/xlink",
                        "xlink:href": "#svg-user",
                      },
                    }),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "dropdown-menu header__dropdown",
                attrs: { "aria-labelledby": "js--login" },
              },
              [
                _c("div", { staticClass: "list-group" }, [
                  _c("a", { attrs: { href: _vm.$ceres.urls.myAccount } }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(
                          _vm.$translate("Ceres::Template.loginMyAccount")
                        ) +
                        "\n                "
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      directives: [{ name: "logout", rawName: "v-logout" }],
                      attrs: { href: "#" },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$translate("Ceres::Template.loginLogout")
                          ) +
                          "\n                "
                      ),
                    ]
                  ),
                ]),
              ]
            ),
          ])
        : [
            _c(
              "a",
              {
                attrs: {
                  id: "js--login",
                  "data-toggle": "dropdown",
                  "data-toggle-second": "tooltip",
                  "data-placement": "top",
                  title: _vm.$translate(
                    "OD3dprimaV2::Template.myAccountTooltip"
                  ),
                  "aria-label": _vm.$translate(
                    "OD3dprimaV2::Template.myAccountTooltip"
                  ),
                  href: "#",
                  "aria-expanded": "false",
                  "aria-haspopup": "true",
                  "data-boundary": "viewport",
                },
              },
              [
                _c(
                  "svg",
                  {
                    staticClass: "dia-controls-list__svg",
                    attrs: {
                      xmlns: "http://www.w3.org/2000/svg",
                      width: "22",
                      height: "19",
                    },
                  },
                  [
                    _c("use", {
                      attrs: {
                        "xmlns:xlink": "http://www.w3.org/1999/xlink",
                        "xlink:href": "#svg-user",
                      },
                    }),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "dropdown-menu header__dropdown",
                attrs: { "aria-labelledby": "js--login" },
              },
              [
                _c("div", { staticClass: "list-group" }, [
                  _c(
                    "a",
                    {
                      attrs: {
                        href: _vm.isLogin ? "javascript:void(0)" : "#login",
                        "data-toggle": _vm.isLogin ? false : "modal",
                        "data-testing": "login-select",
                        "aria-label": _vm.$translate("Ceres::Template.login"),
                      },
                      on: {
                        click: function ($event) {
                          _vm.createLoginModal()
                          _vm.unmarkInputFields()
                        },
                      },
                    },
                    [
                      _c("span", { staticClass: "hidden-xs-down" }, [
                        _vm._v(_vm._s(_vm.$translate("Ceres::Template.login"))),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.showRegistration
                    ? _c(
                        "a",
                        {
                          attrs: {
                            href: _vm.urlRegistration,
                            "data-testing": "register-select",
                            "aria-label": _vm.$translate(
                              "Ceres::Template.loginRegister"
                            ),
                          },
                        },
                        [
                          _c("span", { staticClass: "hidden-xs-down" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$translate("Ceres::Template.loginRegister")
                              )
                            ),
                          ]),
                        ]
                      )
                    : _vm._e(),
                ]),
              ]
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }